import { render, staticRenderFns } from "./gc-popup-change-location.vue?vue&type=template&id=58d5fcfa"
import script from "./gc-popup-change-location.vue?vue&type=script&lang=js"
export * from "./gc-popup-change-location.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-change-location.vue?vue&type=style&index=0&id=58d5fcfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports